"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_ACTION_CODE = exports.EXPIRED_ACTION_CODE = exports.INVALID_EMAIL = exports.USER_DISABLED = exports.TOO_MANY_REQUESTS = exports.INVALID_LOGIN_CREDENTIALS = exports.INVALID_CREDENTIAL = exports.USER_NOT_FOUND = exports.INCORRECT_PASSWORD = void 0;
// Legacy error codes (Firebase Auth v8)
exports.INCORRECT_PASSWORD = "auth/wrong-password";
exports.USER_NOT_FOUND = "auth/user-not-found";
// Modern error codes (Firebase Auth v9+)
exports.INVALID_CREDENTIAL = "auth/invalid-credential";
exports.INVALID_LOGIN_CREDENTIALS = "auth/invalid-login-credentials";
exports.TOO_MANY_REQUESTS = "auth/too-many-requests";
exports.USER_DISABLED = "auth/user-disabled";
exports.INVALID_EMAIL = "auth/invalid-email";
// Password reset codes
exports.EXPIRED_ACTION_CODE = "auth/expired-action-code";
exports.INVALID_ACTION_CODE = "auth/invalid-action-code";
